const contactPreferencesInner = {
    contactMethods: [
        {
            tagId: 1437,
            tagTypeId: 110,
            tagTypeName: "contact preference",
            tagName: "phone",
            canMatch: true,
            canEdit: true,
        },
        {
            tagId: 1439,
            tagTypeId: 110,
            tagTypeName: "contact preference",
            tagName: "text",
            canMatch: true,
            canEdit: true,
        },
        {
            tagId: 1438,
            tagTypeId: 110,
            tagTypeName: "contact preference",
            tagName: "email",
            canMatch: true,
            canEdit: true,
        },
    ],

    timeOfDay: [
        //Monday
        {
            day: "Monday",
            times: [
                {
                    tagId: 1582,
                    tagTypeId: 110,
                    tagTypeName: "contact preference",
                    tagName: "morning",
                    canMatch: true,
                    canEdit: true,
                    isMatched: false,
                },
                {
                    tagId: 1583,
                    tagTypeId: 110,
                    tagTypeName: "contact preference",
                    tagName: "afternoon",
                    canMatch: true,
                    canEdit: true,
                    isMatched: false,
                },
                {
                    tagId: 1584,
                    tagTypeId: 110,
                    tagTypeName: "contact preference",
                    tagName: "evening",
                    canMatch: true,
                    canEdit: true,
                    isMatched: false,
                },
            ],
        },
        {
            day: "Tuesday",
            times: [
                {
                    tagId: 1585,
                    tagTypeId: 110,
                    tagTypeName: "contact preference",
                    tagName: "morning",
                    canMatch: true,
                    canEdit: true,
                    isMatched: false,
                },
                {
                    tagId: 1586,
                    tagTypeId: 110,
                    tagTypeName: "contact preference",
                    tagName: "afternoon",
                    canMatch: true,
                    canEdit: true,
                    isMatched: false,
                },
                {
                    tagId: 1587,
                    tagTypeId: 110,
                    tagTypeName: "contact preference",
                    tagName: "evening",
                    canMatch: true,
                    canEdit: true,
                    isMatched: false,
                },
            ],
        },
        {
            day: "Wednesday",
            times: [
                {
                    tagId: 1588,
                    tagTypeId: 110,
                    tagTypeName: "contact preference",
                    tagName: "morning",
                    canMatch: true,
                    canEdit: true,
                    isMatched: false,
                },
                {
                    tagId: 1589,
                    tagTypeId: 110,
                    tagTypeName: "contact preference",
                    tagName: "afternoon",
                    canMatch: true,
                    canEdit: true,
                    isMatched: false,
                },
                {
                    tagId: 1590,
                    tagTypeId: 110,
                    tagTypeName: "contact preference",
                    tagName: "evening",
                    canMatch: true,
                    canEdit: true,
                    isMatched: false,
                },
            ],
        },
        {
            day: "Thursday",
            times: [
                {
                    tagId: 1591,
                    tagTypeId: 110,
                    tagTypeName: "contact preference",
                    tagName: "morning",
                    canMatch: true,
                    canEdit: true,
                    isMatched: false,
                },
                {
                    tagId: 1592,
                    tagTypeId: 110,
                    tagTypeName: "contact preference",
                    tagName: "afternoon",
                    canMatch: true,
                    canEdit: true,
                    isMatched: false,
                },
                {
                    tagId: 1593,
                    tagTypeId: 110,
                    tagTypeName: "contact preference",
                    tagName: "evening",
                    canMatch: true,
                    canEdit: true,
                    isMatched: false,
                },
            ],
        },
        {
            day: "Friday",
            times: [
                {
                    tagId: 1594,
                    tagTypeId: 110,
                    tagTypeName: "contact preference",
                    tagName: "morning",
                    canMatch: true,
                    canEdit: true,
                    isMatched: false,
                },
                {
                    tagId: 1595,
                    tagTypeId: 110,
                    tagTypeName: "contact preference",
                    tagName: "afternoon",
                    canMatch: true,
                    canEdit: true,
                    isMatched: false,
                },
                {
                    tagId: 1596,
                    tagTypeId: 110,
                    tagTypeName: "contact preference",
                    tagName: "evening",
                    canMatch: true,
                    canEdit: true,
                    isMatched: false,
                },
            ],
        },
    ],
};

export const contactPreferences = Object.freeze(contactPreferencesInner);
